import styled from 'styled-components';
import { Navbar } from 'reactstrap';

export const CustomNavbar = styled(Navbar)`
  height: 80px;
`;